export const getPage = <T>(rows: T[], page: number, pageSize: number) => {
  const startIndex = page * pageSize;
  return rows.slice(startIndex, startIndex + pageSize);
};

const notMappedGroupKey = '_';
type GroupBy<T> = Record<string, T[]>;
export const groupBy = <T, K extends keyof T>(array: T[], key: K): GroupBy<T> => {
  return array.reduce<GroupBy<T>>((result, item) => {
    const groupKey = item[key] != undefined ? String(item[key]) : notMappedGroupKey;

    if (!result[groupKey]) {
      if (groupKey == notMappedGroupKey) {
        return {
          [notMappedGroupKey]: [item],
          ...result,
        };
      } else {
        result[groupKey] = [];
      }
    }

    result[groupKey].push(item);
    return result;
  }, {} as GroupBy<T>);
};
